import { render, staticRenderFns } from "./question-form.vue?vue&type=template&id=73622c0e"
import script from "./question-form.vue?vue&type=script&lang=js"
export * from "./question-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports